
import React from 'react';

import './App.css'
import Home from './Home'
import DisplayCart from './DisplayCart'

import {Provider} from 'react-redux';
import {createStore} from 'redux'
import rootReducer from './reducers/index'
const store=createStore(rootReducer)

function RApp(){

    return(
        <div>

            <h1 id='shoppingCart'>Shopping Cart</h1>
            
            <div className='flex-row'>
                <Provider store={store}>
                    <Home />
                    <DisplayCart />
                </Provider>
            </div>
        </div>
    )
}


export default RApp;